import { Action } from 'redux';

export interface TransactionsState {
  loadingTransactions: boolean;
  savingTransaction: boolean;
  removingTransaction: boolean;
  transactions: any[];
  selectedIndex: number | null;
  isEditing: boolean;
  resume: any;
  resumeDay: any;
  loadingResume: boolean;
  filters: {
    dateFrom: string;
    dateTo: string;
    type: string;
    resource: string;
    category: string;
  };
}

export enum TransactionsActionTypes {
  EDITING_START = '@@transactions/EDITING_START',
  EDITING_CANCEL = '@@transactions/EDITING_CANCEL',
  GET_TRANSACTIONS_START = '@@transactions/GET_TRANSACTIONS_START',
  GET_TRANSACTIONS_SUCCESS = '@@transactions/GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_ERROR = '@@transactions/GET_TRANSACTIONS_ERROR',
  SAVE_TRANSACTION_START = '@@transactions/SAVE_TRANSACTION_START',
  SAVE_TRANSACTION_SUCCESS = '@@transactions/SAVE_TRANSACTION_SUCCESS',
  SAVE_TRANSACTION_ERROR = '@@transactions/SAVE_TRANSACTION_ERROR',
  SET_TRANSACTIONS_FILTERS = '@@transactions/SET_TRANSACTIONS_FILTERS',
  GET_RESUME_YEAR_START = '@@transactions/GET_RESUME_YEAR_START',
  GET_RESUME_YEAR_SUCCESS = '@@transactions/GET_RESUME_YEAR_SUCCESS',
  GET_RESUME_YEAR_ERROR = '@@transactions/GET_RESUME_YEAR_ERROR',
  GET_RESUME_DAY_START = '@@transactions/GET_RESUME_DAY_START',
  GET_RESUME_DAY_SUCCESS = '@@transactions/GET_RESUME_DAY_SUCCESS',
  GET_RESUME_DAY_ERROR = '@@transactions/GET_RESUME_DAY_ERROR',
  CLEAR = '@@transactions/CLEAR',
}

export interface TransactionsAction extends Action<TransactionsActionTypes> {
  index?: number;
  transactions?: TransactionsState['transactions'];
  filters?: TransactionsState['filters'];
  resume?: any;
  resumeDay?: any;
}
